export const GET_SERVICE_PROVIDER_USER_CHAT_LIST = null;
export const GET_SERVICE_PROVIDER_USER_CHAT_REUQEST_LIST = null;
export const GET_SERVICE_PROVIDER_USER_CHAT_DETAILS_BY_ID = null;
export const GET_SERVICE_PROVIDER_USER_CHAT_MESSAGES = null;
export const SET_SERVICE_PROVIDER_USER_CHAT_MESSAGE = null;
export const GET_SERVICE_PROVIDER_REQUEST_DETAILS_BY_ID = null;
